/* global axios */
import ApiClient from '../ApiClient';

class CaptainMediaAsset extends ApiClient {
  constructor() {
    super('captain/media_assets', { accountScoped: true });
  }

  // O servidor devolve a LISTA pura (o spec dele exige), e a loja genérica
  // (`storeFactory`) lê `data.payload` e `data.meta`: a lista virava
  // `undefined`, o `getRecords` estourava no `.sort` e a Biblioteca de Mídia
  // do Lumos ficava vazia mesmo com mídias cadastradas (achado na varredura
  // de rotas, 06/10/2026).
  async get({ assistantId } = {}) {
    const resposta = await axios.get(this.url, {
      params: { assistant_id: assistantId },
    });
    const lista = Array.isArray(resposta.data)
      ? resposta.data
      : resposta.data?.payload || [];
    return {
      ...resposta,
      data: { payload: lista, meta: { total_count: lista.length } },
    };
  }

  create({ name, kind, areaSlug, fase, codigo, assistantId, file }) {
    const formData = new FormData();
    formData.append('media_asset[name]', name);
    formData.append('media_asset[kind]', kind);
    formData.append('media_asset[assistant_id]', assistantId);
    if (areaSlug) formData.append('media_asset[area_slug]', areaSlug);
    if (fase) formData.append('media_asset[fase]', fase);
    if (codigo) formData.append('media_asset[codigo]', codigo);
    formData.append('media_asset[file]', file);

    return axios.post(this.url, formData);
  }
}

export default new CaptainMediaAsset();
